import { render, staticRenderFns } from "./ActionsTemplate.vue?vue&type=template&id=352f892e&scoped=true"
import script from "./ActionsTemplate.vue?vue&type=script&lang=js"
export * from "./ActionsTemplate.vue?vue&type=script&lang=js"
import style0 from "./ActionsTemplate.vue?vue&type=style&index=0&id=352f892e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f892e",
  null
  
)

export default component.exports